import dayjs from 'dayjs';
import { useQuery } from 'react-query';
import { SingleRuleForm } from './single-rule-form-data';

const rule: SingleRuleForm = {
  businessJustification: 126,
  customer: {
    customerBranchNumber: '3',
    customerCompanyCode: '4',
    customerName: 'A1',
    customerNumber: '5',
    id: 2,
    segmentId: 309,
  },
  effectiveDate: dayjs(),
  expirationDate: dayjs(),
  marginDelta: -10,
  marginStrategy: 'RETAIL_PRICE',
  requestPriority: 'URGENT',
  vendor: {
    id: 1,
    vendorCode: '10',
    vendorCompanyCode: '20',
    vendorName: 'V1',
  },
};

export type GetRuleRequest = {
  ruleId: string;
};

export function useGetRuleQuery(params: GetRuleRequest) {
  return useQuery([params], async () => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return rule;
  });
}
